
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as feedEv9x6DseJopgjWBW8rvck3NyyoURKBRZCI9LESs4Q_45oMeta } from "/srv/artfield/pages/feed.vue?macro=true";
import { default as aboutSdT44J8Fd058PzUtp_457PbMBQwhTO9m8NPcnFadFltgAMeta } from "/srv/artfield/pages/about.vue?macro=true";
import { default as indexjKzj0Kel8ppdNnBEIYm5VxbQVQqIRJGn_45U1J2U2hGE4Meta } from "/srv/artfield/pages/index.vue?macro=true";
import { default as loginONWXGTvAAm_45oFdCu_1pQIQXDwiEZxvzY1Nwe6WtSBZ8Meta } from "/srv/artfield/pages/login.vue?macro=true";
import { default as confirmIJ7k_XpD5WcMwxtZVjahqs9cqza8wjGb0NK7cmLSaQIMeta } from "/srv/artfield/pages/confirm.vue?macro=true";
import { default as welcomeSTE34j9mbFY2wr83Ji1ALUpOouLkUE7myEkWhDUdZ2EMeta } from "/srv/artfield/pages/welcome.vue?macro=true";
import { default as checkoutNzbhjJrRLvDLtFmnRbtky8VwX98j9ORG_qY9Qd1_45W1gMeta } from "/srv/artfield/pages/checkout.vue?macro=true";
import { default as download7btqCE_zp3AMuESPr90R1iqtarebLnn1ZVPYdxon5E8Meta } from "/srv/artfield/pages/download.vue?macro=true";
import { default as _91id_93EG0ma38qDf9ZQRAkDUxbujbxj9MxMwjK0u_Wf6Kg7iwMeta } from "/srv/artfield/pages/help/[id].vue?macro=true";
import { default as feed5UOJFn8RAP3MBiskHMlXhesUGWNajmjq1eec9W6r1R8Meta } from "/srv/artfield/pages/field/feed.vue?macro=true";
import { default as indexY3uAxlbHDNypMOE9FDqcSa1G15Bs_452awC_45lD9M8lRogMeta } from "/srv/artfield/pages/help/index.vue?macro=true";
import { default as membershipa7bj1ZV_454_2csJcoA92hxouxQKf_48N632a7ZlurfnkMeta } from "/srv/artfield/pages/membership.vue?macro=true";
import { default as _91id_93ZQfTY22c_PMS8R7KQlYTvhv8vbnjnTbmUWdhTs3_45yXQMeta } from "/srv/artfield/pages/reads/[id].vue?macro=true";
import { default as indexOBweRwpRvRSqky4nVpPvmU0LNd1ljbjLgJPadkB1uvcMeta } from "/srv/artfield/pages/field/index.vue?macro=true";
import { default as permissions20cY3Z2QMt6hKAL952QDpLx9b5VuI8XBWddBSj9LftgMeta } from "/srv/artfield/pages/permissions.vue?macro=true";
import { default as indexAU7m4TmEWE0oMknZdAlDoeg_YtZZxkImt3D1kyGWGW8Meta } from "/srv/artfield/pages/reads/index.vue?macro=true";
import { default as reviewWa1iwEksoWQ77JCVB6BSmxsxzthrej8GJL9UMjRQMBoMeta } from "/srv/artfield/pages/field/review.vue?macro=true";
import { default as searchzxcW5l4u4J9hIl3LQcLhFnKAMc7vJND1ZKj_45U24fniMMeta } from "/srv/artfield/pages/field/search.vue?macro=true";
import { default as confirm_45emaildQ0DCuB1ZGkA3DtWpajCPI11Lt3xbGC3vMOIbtYwRlUMeta } from "/srv/artfield/pages/confirm-email.vue?macro=true";
import { default as talentsdahK_45U3tTrCpxP_452sYffFQGppIg9TMo2SmcLo1F3WBsMeta } from "/srv/artfield/pages/field/talents.vue?macro=true";
import { default as mobile_45warningcYuNmdmY9rw2gl8_45o0KYoqcqjJcAhESScKO5K6vas5EMeta } from "/srv/artfield/pages/mobile-warning.vue?macro=true";
import { default as indexHWVdUSC0BY8dUW9Freb1P_451SvTO2wTFaiJQUOFqpbYQMeta } from "/srv/artfield/pages/dashboard/index.vue?macro=true";
import { default as readsryf7pFDhYL1uRRI9Ipggr2b5ycfi1QtGfSr59XGGYM4Meta } from "/srv/artfield/pages/dashboard/reads.vue?macro=true";
import { default as member_45settings1QTcaFaGiFJlWX_45r7ep_45Meki_45kP8xH5vaMGGROhVM7cMeta } from "/srv/artfield/pages/member-settings.vue?macro=true";
import { default as account_45settings0dZ_gDri3__77Nx2wrDgW205ceqGytfa_45RSXRjd98BwMeta } from "/srv/artfield/pages/account-settings.vue?macro=true";
import { default as _91id_93Ee_45Z69QMRFTiv1PTxnZPCXes9OOgtobz6zpD6h2SIPYMeta } from "/srv/artfield/pages/field/board/[id].vue?macro=true";
import { default as _91id_93IWfgfksqRYWNxh01X_45iTP28Rm28ZCbpYY_45EG9t0G9bYMeta } from "/srv/artfield/pages/field/users/[id].vue?macro=true";
import { default as _91id_93y14GocubnTVparE3bMkEMvTSjwzciT8wYP1q3mZ0Kf0Meta } from "/srv/artfield/pages/field/works/[id].vue?macro=true";
import { default as previewNWJ_O2zvbiVXJ0Gxcf0_45I3LASf04_Yb2XjiFAfriia0Meta } from "/srv/artfield/pages/dashboard/preview.vue?macro=true";
import { default as indexnAIeUI2wM0FlO4_Y5oS9wrhkJY6mMQMudEw8SeoZhKoMeta } from "/srv/artfield/pages/field/users/index.vue?macro=true";
import { default as settingsX8y46eWFNA9hyXJTf9TVYJla4vK5nGw4TLu5TgW2sGgMeta } from "/srv/artfield/pages/dashboard/settings.vue?macro=true";
import { default as _91id_93MI6vR8ms1MmJcivhWEqTufuuYEKiU4iALoUkGrPQfUYMeta } from "/srv/artfield/pages/reads/preview/[id].vue?macro=true";
import { default as index6FSGtNTobASnB5Pv1nbRPljvs_45t3jTEXjO0_45ZlDZO6IMeta } from "/srv/artfield/pages/field/profile/index.vue?macro=true";
import { default as welcome_45to_45artfieldZMbTzvicOsCWdWJ0b7m_45DEYjbmOKJGutMfWcwAbGrnwMeta } from "/srv/artfield/pages/welcome-to-artfield.vue?macro=true";
import { default as membershipxZlcL26nZ9kBLUTKjaFgH0r1ARBDR4NzW3v26Vs7LfkMeta } from "/srv/artfield/pages/dashboard/membership.vue?macro=true";
import { default as indexWqH05CMMhADlVpuwnWc3BWFkUcjsAWDxYjR2OrUt_45_45IMeta } from "/srv/artfield/pages/talent/profile/index.vue?macro=true";
import { default as terms_45and_45conditionsR3gpdyI82S_45GbYQc_45KNoDgwR7bE5_45MRCK_450IoUVpBs0Meta } from "/srv/artfield/pages/terms-and-conditions.vue?macro=true";
import { default as indexOt4U9UJpVS5JePXLWuyRxVoahOK7XHpcogf429mIj14Meta } from "/srv/artfield/pages/dashboard/orders/index.vue?macro=true";
import { default as settingslQflZjx1YLk_sd2eIcKqPNquc_i8f_0EcDxNTPeOYOkMeta } from "/srv/artfield/pages/field/profile/settings.vue?macro=true";
import { default as indexSPwMPhgKRc0h_CZX_C1bxoynkUbI3_5ul4zMPLGWxp0Meta } from "/srv/artfield/pages/dashboard/members/index.vue?macro=true";
import { default as indexOYXwC0xKelj_45p7pXuq6oUAi_45aVX08k5oHi5REQZul3cMeta } from "/srv/artfield/pages/dashboard/talents/index.vue?macro=true";
import { default as settingsV0tInoi1aCbnHKp2KKtWH4Gr6YlXY9nvRA9qwdJ66mEMeta } from "/srv/artfield/pages/talent/profile/settings.vue?macro=true";
import { default as indexrBuT21APtgMi0TBzFoKA90iL00TmONIKrvAQRCPl5m8Meta } from "/srv/artfield/pages/dashboard/products/index.vue?macro=true";
import { default as _91id_93bTj9FDD8vY_45_Zl3YMKX2hnNQHOIOjol8wNdRTKlb_jkMeta } from "/srv/artfield/pages/field/users/preview/[id].vue?macro=true";
import { default as indexvbAAJS3pXpb0LDCps6Ae2CoPjapxLER_tXNu1PI8sH0Meta } from "/srv/artfield/pages/dashboard/categories/index.vue?macro=true";
import { default as _91id_93Tbseur3N82_KtofMNIOQgnslA_45BsxwhpKT3oG3EJdXkMeta } from "/srv/artfield/pages/dashboard/talent/profile/[id].vue?macro=true";
import { default as _91id_933VsGvO7JqFP58PVx9Xsjo1DbDxwi89BxYHQBgeaPerEMeta } from "/srv/artfield/pages/dashboard/talent/profile/settings/[id].vue?macro=true";
export default [
  {
    name: "feed",
    path: "/feed",
    meta: { ...(feedEv9x6DseJopgjWBW8rvck3NyyoURKBRZCI9LESs4Q_45oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/feed.vue")
  },
  {
    name: "about",
    path: "/about",
    meta: aboutSdT44J8Fd058PzUtp_457PbMBQwhTO9m8NPcnFadFltgAMeta || {},
    component: () => import("/srv/artfield/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexjKzj0Kel8ppdNnBEIYm5VxbQVQqIRJGn_45U1J2U2hGE4Meta || {},
    component: () => import("/srv/artfield/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/srv/artfield/pages/login.vue")
  },
  {
    name: "confirm",
    path: "/confirm",
    component: () => import("/srv/artfield/pages/confirm.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/srv/artfield/pages/welcome.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("/srv/artfield/pages/checkout.vue")
  },
  {
    name: "download",
    path: "/download",
    meta: download7btqCE_zp3AMuESPr90R1iqtarebLnn1ZVPYdxon5E8Meta || {},
    component: () => import("/srv/artfield/pages/download.vue")
  },
  {
    name: "help-id",
    path: "/help/:id()",
    component: () => import("/srv/artfield/pages/help/[id].vue")
  },
  {
    name: "field-feed",
    path: "/field/feed",
    meta: { ...(feed5UOJFn8RAP3MBiskHMlXhesUGWNajmjq1eec9W6r1R8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/feed.vue")
  },
  {
    name: "help",
    path: "/help",
    meta: indexY3uAxlbHDNypMOE9FDqcSa1G15Bs_452awC_45lD9M8lRogMeta || {},
    component: () => import("/srv/artfield/pages/help/index.vue")
  },
  {
    name: "membership",
    path: "/membership",
    component: () => import("/srv/artfield/pages/membership.vue")
  },
  {
    name: "reads-id",
    path: "/reads/:id()",
    meta: { ...(_91id_93ZQfTY22c_PMS8R7KQlYTvhv8vbnjnTbmUWdhTs3_45yXQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/reads/[id].vue")
  },
  {
    name: "field",
    path: "/field",
    meta: { ...(indexOBweRwpRvRSqky4nVpPvmU0LNd1ljbjLgJPadkB1uvcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/index.vue")
  },
  {
    name: "permissions",
    path: "/permissions",
    component: () => import("/srv/artfield/pages/permissions.vue")
  },
  {
    name: "reads",
    path: "/reads",
    meta: { ...(indexAU7m4TmEWE0oMknZdAlDoeg_YtZZxkImt3D1kyGWGW8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/reads/index.vue")
  },
  {
    name: "field-review",
    path: "/field/review",
    component: () => import("/srv/artfield/pages/field/review.vue")
  },
  {
    name: "field-search",
    path: "/field/search",
    meta: { ...(searchzxcW5l4u4J9hIl3LQcLhFnKAMc7vJND1ZKj_45U24fniMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/search.vue")
  },
  {
    name: "confirm-email",
    path: "/confirm-email",
    component: () => import("/srv/artfield/pages/confirm-email.vue")
  },
  {
    name: "field-talents",
    path: "/field/talents",
    meta: { ...(talentsdahK_45U3tTrCpxP_452sYffFQGppIg9TMo2SmcLo1F3WBsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/talents.vue")
  },
  {
    name: "mobile-warning",
    path: "/mobile-warning",
    component: () => import("/srv/artfield/pages/mobile-warning.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(indexHWVdUSC0BY8dUW9Freb1P_451SvTO2wTFaiJQUOFqpbYQMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-reads",
    path: "/dashboard/reads",
    meta: { ...(readsryf7pFDhYL1uRRI9Ipggr2b5ycfi1QtGfSr59XGGYM4Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/reads.vue")
  },
  {
    name: "member-settings",
    path: "/member-settings",
    component: () => import("/srv/artfield/pages/member-settings.vue")
  },
  {
    name: "account-settings",
    path: "/account-settings",
    component: () => import("/srv/artfield/pages/account-settings.vue")
  },
  {
    name: "field-board-id",
    path: "/field/board/:id()",
    meta: { ...(_91id_93Ee_45Z69QMRFTiv1PTxnZPCXes9OOgtobz6zpD6h2SIPYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/board/[id].vue")
  },
  {
    name: "field-users-id",
    path: "/field/users/:id()",
    meta: { ...(_91id_93IWfgfksqRYWNxh01X_45iTP28Rm28ZCbpYY_45EG9t0G9bYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/users/[id].vue")
  },
  {
    name: "field-works-id",
    path: "/field/works/:id()",
    meta: { ...(_91id_93y14GocubnTVparE3bMkEMvTSjwzciT8wYP1q3mZ0Kf0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/works/[id].vue")
  },
  {
    name: "dashboard-preview",
    path: "/dashboard/preview",
    meta: previewNWJ_O2zvbiVXJ0Gxcf0_45I3LASf04_Yb2XjiFAfriia0Meta || {},
    component: () => import("/srv/artfield/pages/dashboard/preview.vue")
  },
  {
    name: "field-users",
    path: "/field/users",
    component: () => import("/srv/artfield/pages/field/users/index.vue")
  },
  {
    name: "dashboard-settings",
    path: "/dashboard/settings",
    meta: settingsX8y46eWFNA9hyXJTf9TVYJla4vK5nGw4TLu5TgW2sGgMeta || {},
    component: () => import("/srv/artfield/pages/dashboard/settings.vue")
  },
  {
    name: "reads-preview-id",
    path: "/reads/preview/:id()",
    component: () => import("/srv/artfield/pages/reads/preview/[id].vue")
  },
  {
    name: "field-profile",
    path: "/field/profile",
    meta: { ...(index6FSGtNTobASnB5Pv1nbRPljvs_45t3jTEXjO0_45ZlDZO6IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/profile/index.vue")
  },
  {
    name: "welcome-to-artfield",
    path: "/welcome-to-artfield",
    component: () => import("/srv/artfield/pages/welcome-to-artfield.vue")
  },
  {
    name: "dashboard-membership",
    path: "/dashboard/membership",
    meta: { ...(membershipxZlcL26nZ9kBLUTKjaFgH0r1ARBDR4NzW3v26Vs7LfkMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/membership.vue")
  },
  {
    name: "talent-profile",
    path: "/talent/profile",
    meta: { ...(indexWqH05CMMhADlVpuwnWc3BWFkUcjsAWDxYjR2OrUt_45_45IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/talent/profile/index.vue")
  },
  {
    name: "terms-and-conditions",
    path: "/terms-and-conditions",
    component: () => import("/srv/artfield/pages/terms-and-conditions.vue")
  },
  {
    name: "dashboard-orders",
    path: "/dashboard/orders",
    meta: { ...(indexOt4U9UJpVS5JePXLWuyRxVoahOK7XHpcogf429mIj14Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/orders/index.vue")
  },
  {
    name: "field-profile-settings",
    path: "/field/profile/settings",
    meta: { ...(settingslQflZjx1YLk_sd2eIcKqPNquc_i8f_0EcDxNTPeOYOkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/field/profile/settings.vue")
  },
  {
    name: "dashboard-members",
    path: "/dashboard/members",
    meta: { ...(indexSPwMPhgKRc0h_CZX_C1bxoynkUbI3_5ul4zMPLGWxp0Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/members/index.vue")
  },
  {
    name: "dashboard-talents",
    path: "/dashboard/talents",
    meta: { ...(indexOYXwC0xKelj_45p7pXuq6oUAi_45aVX08k5oHi5REQZul3cMeta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/talents/index.vue")
  },
  {
    name: "talent-profile-settings",
    path: "/talent/profile/settings",
    meta: { ...(settingsV0tInoi1aCbnHKp2KKtWH4Gr6YlXY9nvRA9qwdJ66mEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/talent/profile/settings.vue")
  },
  {
    name: "dashboard-products",
    path: "/dashboard/products",
    meta: { ...(indexrBuT21APtgMi0TBzFoKA90iL00TmONIKrvAQRCPl5m8Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/products/index.vue")
  },
  {
    name: "field-users-preview-id",
    path: "/field/users/preview/:id()",
    component: () => import("/srv/artfield/pages/field/users/preview/[id].vue")
  },
  {
    name: "dashboard-categories",
    path: "/dashboard/categories",
    meta: { ...(indexvbAAJS3pXpb0LDCps6Ae2CoPjapxLER_tXNu1PI8sH0Meta || {}), ...{"middleware":"admin-auth"} },
    component: () => import("/srv/artfield/pages/dashboard/categories/index.vue")
  },
  {
    name: "dashboard-talent-profile-id",
    path: "/dashboard/talent/profile/:id()",
    meta: { ...(_91id_93Tbseur3N82_KtofMNIOQgnslA_45BsxwhpKT3oG3EJdXkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/dashboard/talent/profile/[id].vue")
  },
  {
    name: "dashboard-talent-profile-settings-id",
    path: "/dashboard/talent/profile/settings/:id()",
    meta: { ...(_91id_933VsGvO7JqFP58PVx9Xsjo1DbDxwi89BxYHQBgeaPerEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/srv/artfield/pages/dashboard/talent/profile/settings/[id].vue")
  }
]